import { CHECKOUT_STEPS, CheckoutStep } from '../types';

export const DEFAULT_CHECKOUT_STEP: CheckoutStep = 'works';

export const STEPPER_STEPS: { labelKey: string; step: CheckoutStep }[] = [
  { labelKey: 'orderReview.steps.selectWork', step: 'works' },
  { labelKey: 'orderReview.steps.addDetails', step: 'details' },
  { labelKey: 'orderReview.steps.review', step: 'review' },
];

export const isCheckoutStep = (value: unknown): value is CheckoutStep =>
  typeof value === 'string' && CHECKOUT_STEPS.includes(value as CheckoutStep);

export const checkoutStepIndex = (step: CheckoutStep): number =>
  CHECKOUT_STEPS.indexOf(step);
